module.exports = __webpack_public_path__ + "img/pMember-banner.f29cbc9a.jpg";